import * as joint from '@joint/core';
import { Jurisdiction, ShapeType } from './types';
import { DefaultShapeColors } from './constants';
import { Node } from './node-base';

// Define a custom element to represent a Corporation/CFC Entity Node
export class CorporationCFC extends Node {
    defaults() {
        return {
            type: 'CorporationCFC',
            svgPath: '/icons/Corporation.svg',
            attrs: {
                body: {
                    fill: '#0A2065',
                    stroke: '#FFFFFF',
                    strokeWidth: 2,
                    width: 'calc(w)',
                    height: 'calc(h)',
                    rx: 10,
                    ry: 10,
                },
                label: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.5*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    fontWeight: 'bold',
                    text: 'Corporation',
                },
                label2: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.75*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    text: '',
                }
            },
            markup: [{
                tagName: 'rect',
                selector: 'body'
            }, {
                tagName: 'text',
                selector: 'label'
            }, {
                tagName: 'text',
                selector: 'label2'
            }],
        }
    }
}
Object.assign(joint.shapes, { CorporationCFC });

// Define a custom element to represent a Branch Entity Node
export class Branch extends Node {
    defaults() {
        return {
            type: 'Branch',
            svgPath: '/icons/Branch.svg',
            attrs: {
                body: {
                    fill: '#0A2065',
                    stroke: '#FFFFFF',
                    strokeWidth: 2,
                    width: 'calc(w)',
                    height: 'calc(h)',
                    rx: 'calc(w / 2)',
                    ry: 'calc(h / 2)',
                    cx: 'calc(w / 2)',
                    cy: 'calc(h / 2)',
                },
                backgroundRect: {
                    fill: 'transparent',
                    stroke: 'none',
                    width: 'calc(w)',
                    height: 'calc(h)',
                },
                label: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.5*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    fontWeight: 'bold',
                    text: 'Branch',
                },
                label2: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.75*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    text: '',
                }
            },
            markup: [{
                tagName: 'rect',
                selector: 'backgroundRect'
            }, {
                tagName: 'ellipse',
                selector: 'body'
            }, {
                tagName: 'text',
                selector: 'label'
            }, {
                tagName: 'text',
                selector: 'label2'
            }],
        }
    }
}

// Define a custom element to represent a Third Party Entity Node
export class ThirdParty extends Node {
    defaults() {
        return {
            type: 'ThirdParty',
            svgPath: '/icons/ThirdParty.svg',
            attrs: {
                body: {
                    fill: 'gray',
                    stroke: '#FFFFFF',
                    strokeWidth: 2,
                    width: 'calc(w)',
                    height: 'calc(h)',
                    rx: 'calc(w / 2)',
                    ry: 'calc(h / 2)',
                    cx: 'calc(w / 2)',
                    cy: 'calc(h / 2)',
                },
                backgroundRect: {
                    fill: 'transparent',
                    stroke: 'none',
                    width: 'calc(w)',
                    height: 'calc(h)',
                },
                label: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.5*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    fontWeight: 'bold',
                    text: 'Third Party',
                },
                label2: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.75*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    text: '',
                }
            },
            markup: [{
                tagName: 'rect',
                selector: 'backgroundRect'
            }, {
                tagName: 'ellipse',
                selector: 'body'
            }, {
                tagName: 'text',
                selector: 'label'
            }, {
                tagName: 'text',
                selector: 'label2'
            }],
        }
    }
}

// Legacy BranchThirdParty class kept for backward compatibility
export class BranchThirdParty extends Node {
    defaults() {
        return {
            type: 'BranchThirdParty',
            svgPath: '/icons/BranchThirdParty.svg',
            attrs: {
                body: {
                    fill: 'gray',
                    stroke: '#FFFFFF',
                    strokeWidth: 2,
                    width: 'calc(w)',
                    height: 'calc(h)',
                    rx: 'calc(w / 2)',
                    ry: 'calc(h / 2)',
                    cx: 'calc(w / 2)',
                    cy: 'calc(h / 2)',
                },
                backgroundRect: {
                    fill: 'transparent',
                    stroke: 'none',
                    width: 'calc(w)',
                    height: 'calc(h)',
                },
                label: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.5*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    fontWeight: 'bold',
                    text: 'Corporation',
                },
                label2: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.75*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    text: '',
                }
            },
            markup: [{
                tagName: 'rect',
                selector: 'backgroundRect'
            }, {
                tagName: 'ellipse',
                selector: 'body'
            }, {
                tagName: 'text',
                selector: 'label'
            }, {
                tagName: 'text',
                selector: 'label2'
            }],
        }
    }
}
Object.assign(joint.shapes, { Branch, ThirdParty, BranchThirdParty });

// Define a custom element to represent a Partnership Entity Node
export class Partnership extends Node {
    defaults() {
        return {
            type: 'Partnership',
            svgPath: '/icons/Partnership.svg',
            attrs: {
                body: {
                    fill: '#0A2065',
                    stroke: '#FFFFFF',
                    strokeWidth: 2,
                    width: 'calc(w)',
                    height: 'calc(h)',
                    points: '0,calc(h), calc(w/2),0, calc(w),calc(h)'
                },
                backgroundRect: {
                    fill: 'transparent',
                    stroke: 'none',
                    width: 'calc(w)',
                    height: 'calc(h)',
                },
                label: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    refY: 0.25,
                    x: 'calc(0.5*w)',
                    y: 'calc(0.5*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    fontWeight: 'bold',
                    text: 'Corporation',
                },
                label2: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    refY: 0.25,
                    x: 'calc(0.5*w)',
                    y: 'calc(0.75*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    text: '',
                }
            },
            markup: [{
                tagName: 'rect',
                selector: 'backgroundRect'
            }, {
                tagName: 'polygon',
                selector: 'body'
            }, {
                tagName: 'text',
                selector: 'label'
            }, {
                tagName: 'text',
                selector: 'label2'
            }],
        }
    }
}
Object.assign(joint.shapes, { Partnership });


// Define a custom element to represent a Hybrid Entity Node
export class HybridEntity extends Node {
    defaults() {
        return {
            type: 'HybridEntity',
            svgPath: '/icons/HybridEntity.svg',
            attrs: {
                body: {
                    fill: '#0A2065',
                    stroke: '#FFFFFF',
                    strokeWidth: 2,
                    width: 'calc(w)',
                    height: 'calc(h)',
                    d: 'M 0 0 L calc(w) 0 L calc(w) calc(h) L 0 calc(h) Z M 0 calc(h) L calc(w/2) 0 L calc(w) calc(h)'
                },
                label: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.5*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    fontWeight: 'bold',
                    text: 'Corporation',
                },
                label2: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.75*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    text: '',
                }
            },
            markup: [{
                tagName: 'path',
                selector: 'body'
            }, {
                tagName: 'text',
                selector: 'label'
            }, {
                tagName: 'text',
                selector: 'label2'
            }],
        }
    }
}
Object.assign(joint.shapes, { HybridEntity });

// Define a custom element to represent a Reverse Hybrid Entity Node
export class ReverseHybrid extends Node {
    defaults() {
        return {
            type: 'ReverseHybrid',
            svgPath: '/icons/ReverseHybrid.svg',
            attrs: {
                body: {
                    fill: '#0A2065',
                    stroke: '#FFFFFF',
                    strokeWidth: 2,
                    width: 'calc(w)',
                    height: 'calc(h)',
                    transform: 'rotate(180 calc(w/2) calc(h/2))',
                    d: 'M 0 0 L calc(w) 0 L calc(w) calc(h) L 0 calc(h) Z M 0 calc(h) L calc(w/2) 0 L calc(w) calc(h)'
                },
                label: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.5*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    fontWeight: 'bold',
                    text: 'Corporation',
                },
                label2: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.75*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    text: '',
                }
            },
            markup: [{
                tagName: 'path',
                selector: 'body'
            }, {
                tagName: 'text',
                selector: 'label'
            }, {
                tagName: 'text',
                selector: 'label2'
            }],
        }
    }
}
Object.assign(joint.shapes, { ReverseHybrid });

// Define a custom element to represent a DRE Entity Node
export class Disregarded extends Node {
    defaults() {
        return {
            type: 'Disregarded',
            svgPath: '/icons/Disregarded.svg',
            attrs: {
                body: {
                    fill: '#0A2065',
                    stroke: '#FFFFFF',
                    strokeWidth: 2,
                    width: 'calc(w)',
                    height: 'calc(h)',
                    rx: 10,
                    ry: 10,
                },
                body2: {
                    fill: 'transparent',
                    stroke: '#FFFFFF',
                    strokeWidth: 2,
                    rx: 'calc(w / 2)',
                    ry: 'calc(h / 2)',
                    cx: 'calc(w / 2)',
                    cy: 'calc(h / 2)',
                },
                label: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.5*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    fontWeight: 'bold',
                    text: 'Corporation',
                },
                label2: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w)',
                    y: 'calc(0.75*h)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    text: '',
                }
            },
            markup: [{
                tagName: 'rect',
                selector: 'body'
            }, {
                tagName: 'ellipse',
                selector: 'body2'
            }, {
                tagName: 'text',
                selector: 'label'
            }, {
                tagName: 'text',
                selector: 'label2'
            }],
        }
    }
    
    setStrokeColor(color: string) {
        this.attr('body/stroke', color);
        this.attr('body2/stroke', color);
    }
}
Object.assign(joint.shapes, { Disregarded });

// Define a custom element to represent an Entity Group Node
export class EntityGroup extends Node {
    defaults() {
        return {
            type: 'EntityGroup',
            svgPath: '/icons/EntityGroup.svg',
            attrs: {
                body: {
                    fill: 'transparent',
                    width: 'calc(w)',
                    height: 'calc(h)',
                    strokeWidth: 0,
                    rx: 10,
                    ry: 10,
                    x: 0,
                    y: 0,
                },
                body1: {
                    fill: '#0A2065',
                    stroke: '#FFFFFF',
                    strokeWidth: 2,
                    width: 'calc(w-10)',
                    height: 'calc(h-10)',
                    rx: 10,
                    ry: 10,
                    x: 0,
                    y: 0,
                },
                body2: {
                    fill: '#0A2065',
                    stroke: '#FFFFFF',
                    strokeWidth: 2,
                    width: 'calc(w-10)',
                    height: 'calc(h-10)',
                    rx: 10,
                    ry: 10,
                    x: 10,
                    y: 10,
                },
                label: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w - 5)',
                    y: 'calc(0.5*h - 5)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    fontWeight: 'bold',
                    text: '',
                },
                label2: {
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    x: 'calc(0.5*w - 5)',
                    y: 'calc(0.75*h - 5)',
                    fill: '#FFFFFF',
                    fontSize: 14,
                    fontFamily: '"Open Sans", sans-serif',
                    text: '',
                }
            },
            markup: [
            {
                tagName: 'rect',
                selector: 'body'
            },{
                tagName: 'rect',
                selector: 'body2'
            },
            {
                tagName: 'rect',
                selector: 'body1'
            },
            {
                tagName: 'text',
                selector: 'label'
            },
            {
                tagName: 'text',
                selector: 'label2'
            }],
        }
    }

    setColor(color: string) {
        this.attr('body1/fill', color);
        this.attr('body2/fill', color);
    }
    
    setStrokeColor(color: string) {
        this.attr('body1/stroke', color);
        this.attr('body2/stroke', color);
    }

    setColorByJurisdiction(jurisdiction: Jurisdiction) {
        switch (jurisdiction) {
            case Jurisdiction.US:
                this.setColor(DefaultShapeColors.PrimaryColor);
                break;
            case Jurisdiction.NonUS:
                this.setColor(DefaultShapeColors.SecondaryColor);
                break;
            case Jurisdiction.Mixed:
                this.attr('body1/fill', DefaultShapeColors.PrimaryColor);
                this.attr('body2/fill', DefaultShapeColors.SecondaryColor);
                break;
            default:
                this.setColor(DefaultShapeColors.PrimaryColor);
                break;
        }
    }
}
Object.assign(joint.shapes, { EntityGroup });

export function createEntityNode(shapeType: ShapeType): Node {
    switch (shapeType) {
        case ShapeType.Branch:
            return new Branch();
        case ShapeType.ThirdParty:
            return new ThirdParty();
        case ShapeType.Partnership:
            return new Partnership();
        case ShapeType.HybridEntity:
            return new HybridEntity();
        case ShapeType.ReverseHybridEntity:
            return new ReverseHybrid();
        case ShapeType.DRE:
            return new Disregarded();
        case ShapeType.Group:
            return new EntityGroup();
        case ShapeType.CorporationCFC:
        default:
            return new CorporationCFC();
    }
}
